<template lang="pug">
.soon
  .soon-intro.u-textCenter
    AppTitle.u-mb-sm(:title="$t('mantra')")
    p.u-text-lg.u-mb-xm(v-html="$t('desc')")
    AppLink(to="/" class="button-link ") {{$t('back')}}

  .soon-img
    img(src='/soon.png', srcset='/soon.png 1x, /soon@2x.png 2x')
  .soon-footer
    .grid.is-widescreen-8.is-desktop-10.is-center
      .column
        Homer
</template>

<style lang="stylus">
$clSoon = #35124b

div.app.is-soon
  background: $clSoon

  .footer
    border-top: none
    background: $clSoon
    color: $clWhite
    margin-left: -12vw
    margin-right: -12vw
    padding-right: 8vw
    padding-left: 8vw

.soon
  &-intro
    background: $clWhite
    margin-left: -12vw
    margin-right: -12vw
    padding: unitRes(200, 400) 8vw unitRes(100, 200)

  &-img
    margin-left: -12vw
    margin-right: -12vw
    position: relative
    z-index: 2
    margin-bottom: -4px
    background: $clWhite

    img
      display: block
      width: 110%
      max-width: 110%
      margin-left: -5%

  &-footer
    padding: 8vw 0
    color: $clWhite
</style>

<script>
import Homer from '~/components/Homer';

export default {
  name: 'Soon',
  components: {
    Homer
  }
};
</script>

<i18n>
{
  "en": {
    "mantra":"Oh wow, you're such| an explorer!",
    "desc":"Your discovery just encouraged us to pick up the pace! <br> We will get this done in no time.",
    "back":"Back to home"
  },
  "ar": {
    "mantra":"رائع! يبدو أنك مستكشفٌ ماهر!",
    "desc":"لقد شجعنا اكتشافك على تسريع الوتيرة! <br> ستري هذا خلال وقت قصير.",
    "back":"العودة للرئيسية"
    }
}
</i18n>
